import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import UserItem from '../../components/UserItem';
import api from '../../core/api';
import {
  CircularProgress,
  List,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@material-ui/core';

import styles from './styles.module.css';

const ClientsPage = ({history}) => {
  const [clients, setClients] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setIsFirstLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filterValue, setFilterValue] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('');
  const [newsletterType, setNewsletterType] = useState();
  const [error, setError] = useState(false);

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleFilterChange = event => {
    setFilterValue(event.target.value);
    setCurrentPage(1);
  };

  const handleSubscriptionTypeChange = event => {
    setSubscriptionType(event.target.value);
    setCurrentPage(1);
  };

  const handleNewsletterTypeChange = event => {
    setNewsletterType(event.target.value);
    setCurrentPage(1);
  };

  async function fetchUsers() {
    try {
      if (clients.length < 1) {
        setFirstLoading(true);
      }
      setIsFirstLoading(true);

      const filters = {
        name: filterValue,
        premium: subscriptionType,
        newsletter: newsletterType,
      };

      const {data} = await api.get('users/clients', {
        params: {
          page: currentPage,
          pageSize,
          filters,
          subscriptionType,
        },
      });
      setClients(data.users);
      setTotalPages(data.totalUsers);
    } catch (err) {
      setError(true);
    } finally {
      setError(false);
      setFirstLoading(false);
      setIsFirstLoading(false);
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [currentPage, pageSize, filterValue, subscriptionType, newsletterType]);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchUsers}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      {firstLoading ? (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <span style={{paddingTop: '10em'}}>
            <CircularProgress size={100} />
            <p> Carregando... </p>
          </span>
        </div>
      ) : (
        <div>
          <div className={styles['filter-bar']}>
            <TextField
              variant="outlined"
              label="Buscar por"
              value={filterValue}
              onChange={handleFilterChange}
            />
            <FormControl>
              <InputLabel id="subscription-type-label">
                Receber Newsletter?
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={newsletterType}
                onChange={handleNewsletterTypeChange}>
                <MenuItem value={undefined}>Todos</MenuItem>
                <MenuItem value={true}>Sim</MenuItem>
                <MenuItem value={false}>Não</MenuItem>
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel id="subscription-type-label">
                Tipo de Plano
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={subscriptionType}
                onChange={handleSubscriptionTypeChange}>
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="N">New</MenuItem>
                <MenuItem value="F">Free</MenuItem>
                <MenuItem value="M">Mensal</MenuItem>
                <MenuItem value="Y">Anual</MenuItem>
                <MenuItem value="G">Gift</MenuItem>
                <MenuItem value="P">Parceiro especial</MenuItem>
              </Select>
            </FormControl>
          </div>

          <TablePagination
            component="div"
            count={totalPages}
            page={currentPage - 1}
            labelRowsPerPage={'Itens por página:'}
            onChangePage={handleChangePage}
            rowsPerPage={pageSize}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </span>
            </div>
          ) : (
            <List>
              {clients.map(client => (
                <UserItem
                  key={client.id}
                  history={history}
                  user={client}
                  refetch={fetchUsers}
                />
              ))}
            </List>
          )}
          <TablePagination
            component="div"
            count={totalPages}
            page={currentPage - 1}
            labelRowsPerPage={'Itens por página:'}
            onChangePage={handleChangePage}
            rowsPerPage={pageSize}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}
    </Dashboard>
  );
};

export default ClientsPage;
